export default "__VITE_ASSET__BFNrMQLZ__"